document.addEventListener("turbo:load", function() {
  // Selecciona el botón de envío basado en el atributo data-role
  var botonEnviar = document.querySelector('[data-role="submit-button"]');
  if (botonEnviar) {
    botonEnviar.addEventListener('click', function(e) {
      // Muestra el spinner cuando se haga clic en el botón
      var spinner = document.getElementById('spinner');
      if (spinner) {
        spinner.style.display = 'flex';
      }
    });
  }
});

// Ocultar spinner cuando Turbo termina de renderizar (ej. errores de validación)
document.addEventListener("turbo:render", function() {
  var spinner = document.getElementById('spinner');
  if (spinner) {
    spinner.style.display = 'none';
  }
});

